/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const analyticsCampaignAreaDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	countryName: z.string(),
	regionName: z.string().nullable(),
})

export type AnalyticsCampaignAreaDataSchema = z.infer<typeof analyticsCampaignAreaDataSchema>
